import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { PsychAppointmentBookingSource } from '../../resources';

export type PatientMatchWithProviderInput = {
  providerId: string;
  fromDatetime: string;
  psychiatryBookingSource?: PsychAppointmentBookingSource;
};

export type PatientMatchWithProviderOutput = {
  data: {
    created: boolean;
    error?: string;
  };
};

export type PatientMatchWithProviderErrorOutput = {
  error?: string;
};

export const patientMatchWithProvider = (data: PatientMatchWithProviderInput) => restClient.request<PatientMatchWithProviderOutput>('/api/v1/match', {
  method: 'POST',
  data: snakecaseKeys(data),
});
